module.exports = __webpack_public_path__ + "img/PA.931bfe6b.svg";